import styled from 'styled-components'

interface IBudgetCategoryCardDetailsBreakdownRowIconStyledProps {
  color: string
  striped?: boolean
}

export const BudgetCategoryCardDetailsBreakdownRowIconStyled = styled.div<IBudgetCategoryCardDetailsBreakdownRowIconStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  display: inline-block;
  height: ${(props) => props.theme.typography.pxToRem(16)};
  width: ${(props) => props.theme.typography.pxToRem(16)};
  margin-right: 0.25em;
  vertical-align: sub;

  border-radius: 50%;
  background-color: ${(props) => props.theme.colors[props.color]};
  ${(props) =>
    props.striped &&
    `
  background-image: repeating-linear-gradient( 45deg, transparent, transparent 5px, ${
    props.theme.colors.white
  } 5px, ${props.theme.colors.white} 10px );
  border: 1px solid ${props.theme.colors[props.color]}
  `}
`
